module.exports = __webpack_public_path__ + "img/createsucc.cd613b37.png";